import React, { useEffect, useState } from 'react';

function AboutUs() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `About | Scan360`;

    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-12 text-gray-800">
      <h1 className="text-3xl font-bold text-blue-700 mb-6">About Scan360</h1>

      <p className="mb-6 text-lg">
        <strong>Scan360</strong> is a modern platform built to help investors, traders, and analysts make smarter decisions
        in the stock market. Our mission is to simplify the complexity of financial data and transform it into meaningful insights.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our Mission</h2>
      <p className="mb-6">
        When a high-frequency trading giant pocketed ₹30,000 crore from the Indian markets, it became clear: the playing field in the options market is anything but level for retail traders. Competing with lightning-fast algorithms is a losing game.
        That's why we're building a different path — a powerful, easy-to-use tool designed for retail swing traders in the cash market. Our goal is simple: give everyday traders the data, insights, and edge they need to win.
      </p>

      <p className="mb-6">
        We aim to empower users with various financial metrics, smart filtering tools, and industry-level tracking so they
        can scan opportunities across multiple sectors — all in one place. We want to capture all the data which impact stock market. And we also want to focus on alternate data sources. Be it how the number of new job openings affects software companies, how marketing spending affects FMCG companies, social media following, how the number of app downloads impacts Zomato, or how gold prices influence jewelry stocks and gold finance companies. At Scan360, we're all about data and how it impacts stocks.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Currently Working On</h2>
      <ul className="list-disc list-inside space-y-3 mb-6">
        <li>
          Adding More data sources - China Commodities & Chemical prices, Agri input prices, US Commodities prices, Indian Chemical Prices etc.
        </li>
        <li>
          Macro data for G20 - GDP, GDP per capita, Interest Rates, Power consumption per head, Internet consumption per head, AI consumption per head etc.
        </li>
        <li>
          3 Year and 5 Year stock Performance on dash board. Cover more international stocks and sectors.
        </li>
        <li>
          User generated content - link submissions, bull vs bear, image or article submission.
        </li>
        <li>
          Search deep history feature inside news and announcements. 
        </li>
        <li>
          Social Media scans - twitter, reddit, youtube.
        </li>
        <li>
          More bull vs bear case, timeline news and more interviews.
        </li>
        <li>
          Adding Yearly P&L, Balance Sheets, Share Holdings, Annual Reports, Con-calls, Credit Reports.
        </li>
        <li>
          Company Group affiliations and trade partnership - Global and domestic.
        </li>
        <li>
          Adding More advanced data based modals and scanners, Thematic idea evaluation.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Why Choose Us?</h2>
      <p className="mb-6">
        Whether you're a retail investor or a seasoned analyst, Scan360 delivers the clarity and speed you need to stay ahead in the markets.
        Our commitment is to transparency, simplicity, and user-focused innovation.
      </p>

      <p className="text-base text-gray-600">
        Built with ❤️ by finance and tech enthusiasts. If you have feedback or collaboration ideas, feel free to <a href="/contact" className="text-blue-600 underline">contact us</a>.
      </p>
    </div>
  );
}

export default AboutUs;
